<template>
  <div class="row position-relative organization-settings">
    <div class="col col-12">
      <Wrapper>
        <div class="font-size-base">
          <ListItemAccount
            v-for="admin in admins.admins"
            :key="`admin_${admin.id}`"
            v-bind="{
              accountId: admin.id,
              type: 'profile',
              ref: admin.id,
              avatar: admin.avatar,
              size: 64,
              name: $filters.displayName(admin),
              approved: admin.approved,
              role: admin.id === account.owner && 'Owner',
            }"
            class="py-3"
          >
            <template slot="action" class="container-admins">
              <ChangeRole
                v-if="admin.id !== account.owner"
                :value="admin.role"
                :items="items"
                :admin="admin.id"
                @role-changed="openRoleChange"
              />
              <Icon
                v-if="admin.id !== account.owner"
                :ref="`admin_${admin.id}`"
                class="cursor-pointer"
                name="trash"
                width="24"
                @click="openDeleteConfirm(admin.id)"
              />
            </template>
          </ListItemAccount>
        </div>
        <HeraButton
          class="btn-secondary-simple d-flex align-items-center mt-5"
          @click="goToSettings"
        >
          <Icon class="h-mr-3" name="add" width="24" />
          {{ $t('_web_organization_admins-add', 'Add Admin') }}
        </HeraButton>
      </Wrapper>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import { PROFILE } from '@/constants/accounts';
import ROUTER_NAMES_ACCOUNT from '@/constants/router/account';
import HeraButton from '@/components/atoms/HeraFormBtn';
import Wrapper from '../PanelWrapper';

import ListItemAccount from '@/components/common/ListItemAccount';

import ChangeRole from './ChangeRole';
import Icon from '@/components/atoms/Icon';

export default {
  name: 'AccountSettingsOrganization',
  components: {
    ListItemAccount,
    Wrapper,
    HeraButton,
    Icon,
    ChangeRole,
  },
  data() {
    return {
      tempAdmin: {},
      adminsList: null,
      popoverAccountId: '',
      role: '',
      items: [
        {
          label: 'Tournament_manager',
        },
        {
          label: 'Tournament_Operator',
        },
      ],
      showDeleteConfirm: false,
      showRoleChange: false,
      currentAdminId: null,
      isConfirmLoading: false,
      admins: {},
    };
  },
  computed: {
    ...mapState('current', ['account']),
    dummy() {
      return !this.adminsList || !this.adminsList.length
        ? this.$t('_web_organization_admins-not-found', 'Admins Not Found')
        : null;
    },
  },
  async created() {
    this.getAdmins();
    this.adminsList = this.account.adminsList || [];
    this.currentAdminId = (await this.fetchMyOrganizations()).find(
      ({ type }) => type === PROFILE
    ).login;
  },

  methods: {
    ...mapActions([
      'removeOrganizationMember',
      'errorNotify',
      'fetchOrgs',
      'setOrganizationMemberRole',
      'openModal',
      'closeModal',
    ]),
    ...mapActions('my', ['fetchMyOrganizations']),
    showConfirm(accountId, role) {
      this.popoverAccountId = accountId;
      this.role = role;
      this.showDeleteConfirm = true;
    },
    showRole(payload) {
      this.popoverAccountId = payload.admin;
      this.role = payload.selectedValue;
      this.showRoleChange = true;
    },
    goToSettings() {
      this.$router.push({ name: ROUTER_NAMES_ACCOUNT.INVITES });
    },
    onUserThreeDotsClick(admin) {
      this.tempAdmin = admin;
    },

    async getAdmins() {
      this.admins = await this.fetchOrgs({ organisationId: this.account._id });
    },
    openDeleteConfirm(id) {
      this.openModal({
        name: 'HeraConfirm',
        props: {
          text: this.$t(
            '_web_organization_admins-delete',
            'Are you sure you want to delete admin?'
          ),
        },
        events: {
          cancel: this.closeModal,
          confirm: () => this.confirmRemoveAdmin(id),
        },
      });
    },

    openRoleChange(payload) {
      this.openModal({
        name: 'HeraConfirm',
        props: {
          text: this.$t(
            '_web_organization_change_menager',
            'Are you sure you want to change role ?'
          ),
          cancelButtonText: this.$t(
            '_web_organization_admins-delete-cancel',
            'Cancel'
          ),
          confirmButtonText: this.$t('_web_organization_admins-yes', 'Yes'),
        },
        events: {
          cancel: this.closeModal,
          confirm: () => this.confirmRoleChange(payload),
        },
      });
    },
    confirmRemoveAdmin(id) {
      this.isConfirmLoading = true;
      this.removeOrganizationMember(id)
        .then(() => {
          this.adminsList = this.adminsList.filter(({ login }) => login !== id);
          this.account.update({ adminsList: this.adminsList });

          if (this.currentAdminId === id) {
            this.$router.push({
              name: 'switch',
              params: {
                accountType: PROFILE,
                accountId: this.currentAdminId,
              },
            });
          }

          this.showDeleteConfirm = false;
          this.isConfirmLoading = false;
        })
        .catch(({ message }) => {
          this.errorNotify(message);
        })
        .finally(() => {
          this.showDeleteConfirm = false;
          this.getAdmins();
          this.closeModal();
        });
    },
    confirmRoleChange(payload) {
      this.isConfirmLoading = true;

      this.setOrganizationMemberRole({
        accountId: this.account._id,
        orgId: payload.admin,
        role: payload.selectedValue,
      })
        .then(() => {
          this.showRoleChange = false;
          this.isConfirmLoading = false;
        })
        .catch(({ message }) => {
          this.errorNotify(message);
        })
        .finally(() => {
          this.showRoleChange = false;
          this.getAdmins();
          this.tempAdmin = {};
          this.closeModal();
        });
    },
  },
};
</script>

<style lang="scss">
.organization-settings {
  .list-loader {
    min-height: 35vh;
  }
}
.role-dropdown {
  padding: 4px 8px;
  font-size: 14px;
  border-radius: 4px;
  border: 1px solid #ccc;
  background-color: #fff;
  outline: none;
  cursor: pointer;
}

.role-dropdown:focus {
  border-color: #007bff;
}
.container-admins {
  display: flex !important;
  justify-content: space-between;
  width: 400px;
}
</style>
